// The scope is passed straight through as the query's `scope` input: "all"
// lists every business unit, "billable" restricts to units the server
// considers relevant to the period (a plan overlapping it or >=1 event in
// it), and "overage" further restricts server-side to units with a category
// over its included allowance.
export type UnitScope = "all" | "billable" | "overage";

export const UNIT_SCOPE_OPTIONS: { value: UnitScope; label: string }[] = [
  { value: "all", label: "All units" },
  { value: "billable", label: "With plan or usage" },
  { value: "overage", label: "Overage only" },
];
